import { Text } from '@outdoorsyco/bonfire';
import React from 'react';

interface IInlineDescriptionList {
  list: string[];
  separator?: string;
  className?: string;
}

const InlineDescriptionList: React.FC<IInlineDescriptionList> = ({
  list,
  separator = '•',
  className,
}) => (
  <>
    {list.map((item, index, array) => (
      <Text key={item} component="span" className={className}>
        {item}
        {separator && index < array.length - 1 && (
          <span aria-hidden="true">&nbsp;{separator}&nbsp;</span>
        )}
      </Text>
    ))}
  </>
);

export default InlineDescriptionList;
